import { Routes } from '@angular/router';
import { ExerciseComponent } from './exercise/exercise.component';
import { ExerciseManagementComponent } from './exercise-management/exercise-management.component';
import { AuthGuard } from '../../guards/auth.guard';
import { problemRoutes } from '../problem/problem.routes';

export const exerciseRoutes: Routes = [
  {
    path: 'exercises',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {}
    },
    children: [
      {
        path: 'create',
        component: ExerciseComponent,
        data: {
          type: 'create',
          breadcrumb: {
            bcType: 'Display',
            action: 'Create',
            value: 'Exercises',
            type: 'Exercise'
          }
        }
      },
      {
        path: ':exerciseId',
        data: {
          breadcrumb: {
            bcType: 'LookUp',
            value: 'exerciseId',
            type: 'Exercise'
          }
        },
        children: [
          {
            path: 'edit',
            component: ExerciseComponent,
            data: {
              type: 'edit',
              breadcrumb: {
                bcType: 'Display',
                action: 'Edit'
              }
            }
          },
          {
            path: 'manage',
            component: ExerciseManagementComponent,
            data: {
              breadcrumb: {
                bcType: 'Display',
                action: 'Manage',
              }
            }
          },
          ...problemRoutes
        ]
      }
    ]
  },
];
